// extracted by mini-css-extract-plugin
export default {"skeleton":"circle_skeleton__-Vl0f","fadeIn":"circle_fadeIn__6PILg"};